import { use } from 'react';
import { NotificationSocketContext } from './notification-socket-context.js';
export const useNotificationSocket = () => {
    const context = use(NotificationSocketContext);
    if (!context) {
        throw new Error('useNotificationSocket must be used within a NotificationSocketProvider');
    }
    return context;
};
//# sourceMappingURL=use-notification-socket.js.map